module.exports = __webpack_public_path__ + "media/images/map/km-c3b7b1968599ae435ce9218cea6f6932.svg";